import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import config from "../../common/config";

const BookingStatus = ({ startDate, endDate, selectedCar }) => {
  const [selectedOption, setSelectedOption] = useState("All Status");
  const [bookingData, setBookingData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setPageNumber(1);
  };

  function addLeadingZero(number) {
    return number < 10 ? `0${number}` : number.toString();
  }

  // Trigger API fetch when selected status option or global filters change
  useEffect(() => {
    fetchBookingStatus();
  }, [selectedOption, startDate, endDate, selectedCar]);

  const fetchBookingStatus = async () => {
    const today = new Date();
    const day = today.getDate();
    const monthIndex = today.getMonth();
    const year = today.getFullYear();

    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
    const lastDayOfNextMonth = new Date(currentYear, currentMonth + 1, 0);
    const lastDayOfMonth = new Date(currentYear, currentMonth, lastDayOfNextMonth.getDate());

    const fday = firstDayOfMonth.getDate();
    const fmonthIndex = firstDayOfMonth.getMonth();
    const fyear = firstDayOfMonth.getFullYear();
    const fmonth = addLeadingZero(fmonthIndex + 1);
    const fdate1 = addLeadingZero(fday);
    const fdate2 = `${fyear}-${fmonth}-${fdate1}`;

    const lday = lastDayOfMonth.getDate();
    const lmonthIndex = lastDayOfMonth.getMonth();
    const lyear = lastDayOfMonth.getFullYear();
    const lmonth = addLeadingZero(lmonthIndex + 1);
    const ldate1 = addLeadingZero(lday);
    const ldate2 = `${lyear}-${lmonth}-${ldate1}`;

    const carIds = selectedCar ? JSON.parse(selectedCar) : [];

    try {
      let res = await fetch(config.baseUrl + "api/dashboard/booking_status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          from: startDate ? startDate : fdate2,
          to: endDate ? endDate : ldate2,
          car_id: carIds,
          page: pageNumber,
          limit: "all",
          confirmation_status: getStatus(),
        }),
      });
      let resJson = await res.json();
      if (res.status === 200) {
       const sortedData = (resJson.data || []).sort((a, b) => {
         const dateTimeA = new Date(`${a.date}T${a.time}`);
         const dateTimeB = new Date(`${b.date}T${b.time}`);

         return dateTimeB - dateTimeA;
       });

        setBookingData(sortedData);
        if (resJson.data && resJson.data.length > 0) {
          setTotalItems(resJson.totalCount || sortedData.length);
        } else {
          setTotalItems(0);
        }
        setTotalPages(Math.ceil((resJson.totalCount || sortedData.length) / itemsPerPage));
      } else {
        console.log("Data Not retrieved");
      }
    } catch (error) {
      console.log("Error fetching booking status:", error);
    }
  };

  const getStatus = () => {
    if (selectedOption === "Requested") {
      return 1;
    } else if (selectedOption === "Accepted") {
      return 2;
    } else if (selectedOption === "Cancelled") {
      return 3;
    } else {
      return "all";
    }
  };

  const getType = (type) => {
    if (type === "1" || type === "Arrival") {
      return "Airport Arrival";
    } else if (type === "2") {
      return "Airport Departure";
    } else if (type === "3") {
      return "Point To Point(Transfer)";
    } else if (type === "4") {
      return "Singapore Disposal";
    } else if (type === "5") {
      return "Malaysia Disposal";
    }
  };
  
  const getFormattedDate = (date) => {
    const dateObject = new Date(date);

    const day = dateObject?.getDate();
    const monthName = dateObject?.toLocaleString("default", {
      month: "short",
    });
    const year = dateObject?.getFullYear();

    return `${day} ${monthName}, ${year}`;
  };

  statusIdentification(bookingData);
  function statusIdentification(array) {
    if (!Array.isArray(array)) return;
    for (var j = 0; j < array.length; j++) {
      if (array[j].confirmation_status === 1) {
        array[j].confirmation_status1 = "Requested";
        array[j].badgeClass = "warning";
      } else if (array[j].confirmation_status === 2) {
        array[j].confirmation_status1 = "Accepted";
        array[j].badgeClass = "success";
      } else {
        array[j].confirmation_status1 = "Cancelled";
        array[j].badgeClass = "danger";
      }
    }
  }

  useEffect(() => {
    const startIdx = (pageNumber - 1) * itemsPerPage;
    const endIdx = Math.min(startIdx + itemsPerPage, totalItems);
    setStartIndex(startIdx);
    setEndIndex(endIdx);

    setTotalPages(Math.ceil(totalItems / itemsPerPage));
  }, [bookingData, pageNumber, totalItems, itemsPerPage]);

  const recordsToShow = bookingData.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPageNumber(newPage);
    }
  };

  const handleItemsPerPageChange = (size) => {
    setItemsPerPage(size);
    setPageNumber(1);
  };

  return (
    <React.Fragment>
      <Col xl={7}>
        <Card>
          <CardHeader className="d-flex align-items-center">
            <h4 className="card-title flex-grow-1 mb-0">Booking Status</h4>
            <div className="flex-shrink-0">
              <UncontrolledDropdown className="card-header-dropdown">
                <DropdownToggle
                  className="text-reset dropdown-btn"
                  tag="a"
                  role="button"
                >
                  <span className="text-muted">
                    {selectedOption}{" "}
                    <i className="mdi mdi-chevron-down ms-1"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem onClick={() => handleOptionChange("All Status")}>
                    All Status
                  </DropdownItem>
                  <DropdownItem onClick={() => handleOptionChange("Requested")}>
                    Requested{" "}
                  </DropdownItem>
                  <DropdownItem onClick={() => handleOptionChange("Accepted")}>
                    Accepted
                  </DropdownItem>
                  <DropdownItem onClick={() => handleOptionChange("Cancelled")}>
                    Cancelled
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <table className="table table-nowrap table-centered align-middle">
                <thead className="bg-light text-muted">
                  <tr>
                    <th scope="col">Booking ID</th>
                    <th scope="col">Hotel Name</th>
                    <th scope="col">Travel Info</th>
                    <th scope="col">Car Type</th>
                    <th scope="col">Travel Date & Time</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>

                <tbody>
                  {(recordsToShow || []).map((item, key) => (
                    <tr key={key}>
                      <td className="fw-medium">
                        <p className="text-secondary">{item.booking_id}</p>
                      </td>
                      <td>
                        <div className="text-reset">{item.hotel_name}</div>
                      </td>
                      <td>
                        <div className="text-muted">
                          {getType(item.pickup_type)}
                        </div>
                      </td>
                      <td>
                        <div className="text-muted">
                          {item.car_info?.car_brand}-{item.car_info?.car_model}
                        </div>
                      </td>
                      <td>
                        <div className="text-muted">{getFormattedDate(item.date)} - {item.time}</div>
                      </td>
                      <td>
                        <span className={"badge badge-soft-" + item.badgeClass}>
                          {item.confirmation_status1}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-flex align-items-center justify-content-end mt-3 pe-2 gap-3 text-muted fs-13">
              <div className="d-flex align-items-center gap-2">
                <span>Rows per page:</span>
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="button"
                    className="btn btn-sm btn-link text-muted text-decoration-none p-0 border-0 fs-13"
                  >
                    {itemsPerPage} <i className="mdi mdi-chevron-down ms-1"></i>
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem onClick={() => handleItemsPerPageChange(5)}>5</DropdownItem>
                    <DropdownItem onClick={() => handleItemsPerPageChange(10)}>10</DropdownItem>
                    <DropdownItem onClick={() => handleItemsPerPageChange(25)}>25</DropdownItem>
                    <DropdownItem onClick={() => handleItemsPerPageChange(50)}>50</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              <span className="ms-2">
                {totalItems > 0 ? `${startIndex + 1}-${endIndex}` : "0"} of {totalItems}
              </span>

              <div className="d-flex align-items-center gap-2 ms-2">
                <button
                  className="btn btn-sm p-0 text-muted border-0 shadow-none"
                  style={{ background: "transparent" }}
                  onClick={() => handlePageChange(1)}
                  disabled={pageNumber === 1}
                >
                  <i className="mdi mdi-page-first fs-16"></i>
                </button>

                <button
                  className="btn btn-sm p-0 text-muted border-0 shadow-none"
                  style={{ background: "transparent" }}
                  onClick={() => handlePageChange(pageNumber - 1)}
                  disabled={pageNumber === 1}
                >
                  <i className="mdi mdi-chevron-left fs-16"></i>
                </button>

                <button
                  className="btn btn-sm p-0 text-muted border-0 shadow-none"
                  style={{ background: "transparent" }}
                  onClick={() => handlePageChange(pageNumber + 1)}
                  disabled={pageNumber === totalPages || totalPages === 0}
                >
                  <i className="mdi mdi-chevron-right fs-16"></i>
                </button>

                <button
                  className="btn btn-sm p-0 text-muted border-0 shadow-none"
                  style={{ background: "transparent" }}
                  onClick={() => handlePageChange(totalPages)}
                  disabled={pageNumber === totalPages || totalPages === 0}
                >
                  <i className="mdi mdi-page-last fs-16"></i>
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default BookingStatus;